import ReCaptchaProvider from "context/recaptcha";

export const wrapRootElement = ({ element }) => (
  <ReCaptchaProvider>{element}</ReCaptchaProvider>
);
